import { render, staticRenderFns } from "./DeleteCard.vue?vue&type=template&id=55c8b573"
import script from "./DeleteCard.vue?vue&type=script&lang=js"
export * from "./DeleteCard.vue?vue&type=script&lang=js"
import style0 from "./DeleteCard.vue?vue&type=style&index=0&id=55c8b573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports